import React, { useEffect, useRef } from 'react';

import { EVENT_POLICY_TRIGGER_OPTIONS } from '@vlabs/api-bindings/src/luna-client/constants';
import validate from '@vlabs/shared/validators';
import { Control, SettingsItemWrapper } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from './SharedSubFormStyles.module.sass';

const DEFAULT_INTERVAL_VALUE = 1;

export const EventPolicySubForm = ({ fieldName }) => {
  const { t } = useTranslation();

  const createFullName = (name) => (fieldName ? `${fieldName}.${name}` : name);

  const { register, control, formState: { errors }, setValue, getValues } = useFormContext();
  const intervalRef = useRef(null);

  const isTriggerPeriod = useWatch({ name: createFullName('parameters.parameters.event_policy.trigger') })?.value === 'period';

  useEffect(() => {
    if (!isTriggerPeriod) {
      intervalRef.current = getValues(createFullName('parameters.parameters.event_policy.interval'));
    }

    const intervalValue = intervalRef.current ? intervalRef.current : DEFAULT_INTERVAL_VALUE;
    setValue(createFullName('parameters.parameters.event_policy.interval'), isTriggerPeriod ? intervalValue : null);
  }, [isTriggerPeriod]);

  const commonStylesProps = {
    className: st.SettingItem,
    titleClassName: st.SettingItem__Title,
    contentClassName: st.SettingItem__Content,
  };

  return (
    <>
      <SettingsItemWrapper
        data-tooltip-content={t('videoAnalytics:form.event_policy.trigger.tooltip')}
        title={t('videoAnalytics:form.event_policy.trigger.label')}
        {...commonStylesProps}
      >
        <Control.Select
          control={control}
          isClearable
          name={createFullName('parameters.parameters.event_policy.trigger')}
          options={EVENT_POLICY_TRIGGER_OPTIONS.raw}
        />
      </SettingsItemWrapper>

      <SettingsItemWrapper
        data-tooltip-content={!isTriggerPeriod ? t('videoAnalytics:form.event_policy.interval.tooltip') : null}
        disabled={!isTriggerPeriod}
        title={t('videoAnalytics:form.event_policy.interval.label')}
        {...commonStylesProps}
      >
        <Control.Input
          {...register(createFullName('parameters.parameters.event_policy.interval'), {
            min: validate.gte(0),
            validate: {
              number: validate.number(),
              validateInterval: (value) => {
                if (!value && isTriggerPeriod) {
                  return validate.required();
                }
                return true;
              },
            },
          })}
          disabled={!isTriggerPeriod}
          errors={errors}
        />
      </SettingsItemWrapper>
    </>
  );
};
